import React from "react"

type IconProps = React.SVGProps<SVGSVGElement>

const PaymentsIcon: React.FC<IconProps> = (props) => (
  <svg viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M15 12.5V14H3V12.5H15ZM16.5 11V3C16.5 2.17157 15.8284 1.5 15 1.5H3C2.17157 1.5 1.5 2.17157 1.5 3V11C1.5 11.8284 2.17157 12.5 3 12.5V14C1.39489 14 0.0842144 12.7394 0.00390625 11.1543L0 11V3C1.28853e-07 1.34315 1.34315 4.83192e-08 3 0H15L15.1543 0.00390625C16.7394 0.0842146 18 1.39489 18 3V11L17.9961 11.1543C17.9184 12.6883 16.6883 13.9184 15.1543 13.9961L15 14V12.5C15.8284 12.5 16.5 11.8284 16.5 11Z"
      fill="currentColor"
    />
    <path d="M18 3.5V4.5L0 4.5L0 3.5L18 3.5Z" fill="currentColor" />
    <path
      d="M3 10C3 9.44772 3.44772 9 4 9H6C6.55228 9 7 9.44772 7 10V10C7 10.5523 6.55228 11 6 11H4C3.44772 11 3 10.5523 3 10V10Z"
      fill="currentColor"
    />
  </svg>
)

export default PaymentsIcon
